(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["indexPlus-other-mob"] && !Shopify.designMode) return;
  try {
    //缩略图
    let _50thPlusSwiper_mob = new Swiper("._50thPlusSwiper_mob", {
      loop: true,
      spaceBetween: 8,
      slidesPerView: 3,
      freeMode: 1,
      watchSlidesProgress: true,
      autoScrollOffset: 8,
          speed:600,
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
       },
       centeredSlides: true,
    });
    //大图
    let _50thPlusSwiper2_mob = new Swiper("._50thPlusSwiper2_mob", {
      loop: true,
      spaceBetween: 10,
        speed:600,
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
       },
      navigation: {
        nextEl: ".banner-button-next-2",
        prevEl: ".banner-button-prev-2",
      },
      thumbs: {
        swiper: _50thPlusSwiper_mob,
      },
    });
    //保证
    let _50thPlus_guarantee = new Swiper("._50thPlus_guarantee", {
      spaceBetween: 0,
      slidesPerView: "auto",
      watchSlidesProgress: true,
    });
    //ポイント還元キャンペーン一覧
    // let _50thPlus_activity = new Swiper("._50thPlus-activity", {
    //   spaceBetween: 0,
    //   slidesPerView: "auto",
    //   watchSlidesProgress: true,
    // });

       let  _50thPlusNotice = new Swiper("#_50thPlus-notice_mob", {
      loop: true,
      spaceBetween: 10,
        speed:800,
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
       },
      navigation: {
        nextEl: ".notice-next",
        prevEl: ".notice-prev",
      },
    });

        //SAIL
        let SAIL_swiper = new Swiper("#SAIL_swiper", {
    spaceBetween: 0,
   slidesPerView: "auto",
    freeMode: true,
   watchSlidesProgress: true
   });
   let SAIL_swiper2 = new Swiper("#SAIL_swiper2", {
      spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      });
     let SAIL_swiper3 = new Swiper("#SAIL_swiper3", {
      spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      });

         let gift_swiper = new Swiper("#gift_swiper", {
      spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      });
           let nursing_swiper = new Swiper("#nursing_swiper", {
      spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["indexPlus-other-pc"] && !Shopify.designMode) return;
  try {
    //缩略图
    let _50thPlusSwiper = new Swiper("._50thPlusSwiper", {
     loop: true,
     spaceBetween: 5,
     slidesPerView: 5,
  freeMode: 1,
   watchSlidesProgress: true,
    navigation: {
      nextEl: ".banner-button-next",
      prevEl: ".banner-button-prev",
      },
     autoScrollOffset: 8,
       speed:600,
     autoplay: {
    delay: 3000,
      stopOnLastSlide: false,
   disableOnInteraction: false,
     },
     centeredSlides: true,
    });
    //大图
    let _50thPlusSwiper2 = new Swiper("._50thPlusSwiper2", {
      loop: true,
      spaceBetween: 10,
        speed:600,
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
       },
      navigation: {
        nextEl: ".banner-button-next-2",
        prevEl: ".banner-button-prev-2",
      },
     thumbs: {
        swiper: _50thPlusSwiper,
      },
    });

     var popularity_swiper22 = new Swiper("#popularity_swiper", {
      spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".popularity-next-btn2",
          prevEl: ".popularity-pre-btn2",
        },
      });

    var _50thPlusNotice = new Swiper("#_50thPlus-notice_swiper", {
      loop: true,
      spaceBetween: 10,
        speed:800,
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
       },
      navigation: {
        nextEl: ".notice-next",
        prevEl: ".notice-prev",
      },
    });

    //SAIL
    let SAIL_swiper = new Swiper("#SAIL_swiper", {
    spaceBetween: 0,
   slidesPerView: "auto",
    freeMode: true,
   watchSlidesProgress: true,
    navigation: {
    nextEl: ".sail-next-button1",
   prevEl: ".sail-pre-button1",
    },
   });
    //SAIL
    let SAIL_swiper2 = new Swiper("#SAIL_swiper2", {
      spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".sail-next-button2",
          prevEl: ".sail-pre-button2",
        },
      });

          //SAIL
    let SAIL_swiper3 = new Swiper("#SAIL_swiper3", {
      spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".sail-next-button3",
          prevEl: ".sail-pre-button3",
        },
      });




      //all in gift

      let gift_swiper = new Swiper("#gift_swiper", {
      spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".gift-next-button",
          prevEl: ".gift-pre-button",
        },
      });

      //nursing

        let nursing_swiper = new Swiper("#nursing_swiper", {
      spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".nursing-next-button",
          prevEl: ".nursing-pre-button",
        },
      });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["indexPlus-pc_beifen"] && !Shopify.designMode) return;
  try {
    //缩略图
    let _50thPlusSwiper = new Swiper("._50thPlusSwiper", {
     loop: true,
     spaceBetween: 5,
     slidesPerView: 5,
  freeMode: 1,
   watchSlidesProgress: true,
    navigation: {
      nextEl: ".banner-button-next",
      prevEl: ".banner-button-prev",
      },
     autoScrollOffset: 8,
       speed:600,
     autoplay: {
    delay: 3000,
      stopOnLastSlide: false,
   disableOnInteraction: false,
     },
     centeredSlides: true,
    });
    //大图
    let _50thPlusSwiper2 = new Swiper("._50thPlusSwiper2", {
      loop: true,
      spaceBetween: 10,
        speed:600,
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
       },
      navigation: {
        nextEl: ".banner-button-next-2",
        prevEl: ".banner-button-prev-2",
      },
     thumbs: {
        swiper: _50thPlusSwiper,
      },
    });

     var popularity_swiper22 = new Swiper("#popularity_swiper", {
      spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".popularity-next-btn2",
          prevEl: ".popularity-pre-btn2",
        },
      });

    var _50thPlusNotice = new Swiper("#_50thPlus-notice_swiper", {
      loop: true,
      spaceBetween: 10,
        speed:800,
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
       },
      navigation: {
        nextEl: ".notice-next",
        prevEl: ".notice-prev",
      },
    });

    //SAIL
    let SAIL_swiper = new Swiper("#SAIL_swiper", {
    spaceBetween: 0,
   slidesPerView: "auto",
    freeMode: true,
   watchSlidesProgress: true,
    navigation: {
    nextEl: ".sail-next-button1",
   prevEl: ".sail-pre-button1",
    },
   });
    //SAIL
    let SAIL_swiper2 = new Swiper("#SAIL_swiper2", {
      spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
          nextEl: ".sail-next-button2",
          prevEl: ".sail-pre-button2",
        },
      });
  } catch(e) { console.error(e); }
})();

})();
